import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Solution } from './components/Solution';
import { Features } from './components/Features';
import { Audience } from './components/Audience';
import { Pricing } from './components/Pricing';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-[#F5C842] selection:text-gray-900" data-id="element-0">
      <nav className="bg-white/80 backdrop-blur-md sticky top-0 z-50 border-b border-gray-100" data-id="element-1">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
          <div className="flex justify-between items-center h-16" data-id="element-3">
            <div className="flex items-center" data-id="element-4">
              <span className="text-xl font-bold text-[#4AAAA5]" data-id="element-5">
                Crianza<span className="text-[#E8845F]" data-id="element-6">Feliz</span>
              </span>
            </div>
            <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} className="text-sm font-bold text-[#E8845F] hover:text-[#D67350] transition-colors" data-id="element-7">
              Comprar Kit
            </button>
          </div>
        </div>
      </nav>

      <main data-id="element-8">
        <Hero data-id="element-9" />
        <PainPoints data-id="element-10" />
        <Solution data-id="element-11" />
        <Features data-id="element-12" />
        <Audience data-id="element-13" />
        <Pricing data-id="element-14" />
      </main>

      <footer className="bg-gray-50 py-12 border-t border-gray-100" data-id="element-15">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-16">
          <p className="text-gray-400 text-sm" data-id="element-17">
            © {new Date().getFullYear()} Crianza Feliz. Todos los derechos
            reservados.
          </p>
          <p className="text-gray-400 text-xs mt-2" data-id="element-18">
            Este producto es digital. No se enviará ningún producto físico.
          </p>
        </div>
      </footer>
    </div>;
}